import deepmerge from 'deepmerge'
import {
  EventContainer,
  GeneralErrorBoundary,
  IWidgetConfiguration,
  IframeIosMobileFix,
  InitErrorMessage,
  WidgetContext,
  defaultWidgetConfig,
  ignoreErrors,
  injectCss,
  plainConfigValidator,
  widgetFacadeFactory,
} from '@dxp-module/common'
import { createRoot } from 'react-dom/client'
import cssReset from './style.css'
import MiniFcWidget from './MiniFcWidget'
import MINI_WIDGET_CONFIG_SCHEMA from './models/configSchema.json'
import MiniWidgetConfiguration from './models/IMiniWidgetConfiguration'

const createMiniWidget = (
  configuration: IWidgetConfiguration
  // TODO fix no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  const container = document.getElementById(configuration.containerId)
  const root = container && createRoot(container)
  const eventContainer = new EventContainer()
  const facade = widgetFacadeFactory.create(configuration, eventContainer, root)
  // TODO fix no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return new Promise((resolve: (facade: any) => any) => {
    configuration = deepmerge(defaultWidgetConfig, configuration)

    const jsonValidation = plainConfigValidator.validate<
      IWidgetConfiguration | MiniWidgetConfiguration
    >(configuration, MINI_WIDGET_CONFIG_SCHEMA, 'mini-finance-calculator')

    if (jsonValidation !== true) {
      throw jsonValidation
    }

    ignoreErrors.intl()

    injectCss(cssReset)

    root?.render(
      <GeneralErrorBoundary ref={() => resolve(facade)}>
        <IframeIosMobileFix />
        <WidgetContext.Provider value={[configuration, eventContainer]}>
          <MiniFcWidget />
        </WidgetContext.Provider>
      </GeneralErrorBoundary>
    )
  }).catch(error => {
    root?.render(
      <>
        <IframeIosMobileFix />
        <InitErrorMessage
          error={error}
          message="Finance Calculator: Widget orchestration failed."
        />
      </>
    )
    throw error
  })
}

export default createMiniWidget
